import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {MenuItem} from '../../smart/main-layout/navigation/menu-items';
import {
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
  MatExpansionPanelDescription,
  MatExpansionModule,
} from '@angular/material/expansion';
import {RouterLink} from '@angular/router';
import {NgClass} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {MatIconModule} from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'expansion-panel-nav-item',
  templateUrl: './expansion-panel-nav-item.component.html',
  styleUrls: ['./expansion-panel-nav-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NgClass, TranslatePipe, MatExpansionModule, MatIconModule],
})
export class ExpansionPanelNavItemComponent {
  @Input() isActive?: boolean = false;
  @Input() navItem: MenuItem;

  @Output() navigate = new EventEmitter();
  @ViewChild('expansionPanel') expansionPanel: MatExpansionPanel;
  @Input() panelNavItem: MenuItem;
  @Input()
  get currentRoute(): string {
    return this._currentRoute;
  }
  set currentRoute(value: string) {
    this._currentRoute = value;
    const isPanelActive = this.panelNavItem.menuItems?.find(({routerLink}) => value.startsWith(routerLink));
    setTimeout(() => {
      !!isPanelActive ? this.expansionPanel?.open() : this.expansionPanel?.close();
    }, 450);
  }
  private _currentRoute: string;

  constructor() {}

  public onNavigate() {
    this.navigate.emit();
  }
}
